// Thin fetch wrapper that talks to the SAME shared backend as the mobile app.
const BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

async function request(path, options) {
  const res = await fetch(`${BASE}${path}`, {
    headers: { "Content-Type": "application/json" },
    ...options,
  });
  if (!res.ok) {
    let detail = `Request failed (${res.status})`;
    try {
      const body = await res.json();
      detail = body.detail || detail;
    } catch {}
    throw new Error(detail);
  }
  if (res.status === 204) return undefined;
  return res.json();
}

export const api = {
  get: (p) => request(p),
  post: (p, body) => request(p, { method: "POST", body: JSON.stringify(body) }),
  put: (p, body) => request(p, { method: "PUT", body: JSON.stringify(body) }),
  del: (p) => request(p, { method: "DELETE" }),
  upload: async (p, formData) => {
    const res = await fetch(`${BASE}${p}`, { method: "POST", body: formData });
    if (!res.ok) {
      let detail = `Upload failed (${res.status})`;
      try { const b = await res.json(); detail = b.detail || detail; } catch {}
      throw new Error(detail);
    }
    return res.json();
  },
  download: async (p, filename) => {
    const res = await fetch(`${BASE}${p}`);
    if (!res.ok) throw new Error(`Download failed (${res.status})`);
    const blob = await res.blob();
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename || "download";
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(url);
  },
};

export const ROLES = ["Admin", "Tutor", "HOT", "Assessor", "Rider"];
